
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rims/transportbil/ford-transit-custom",
      function () {
        return require("private-next-pages/rims/transportbil/ford-transit-custom.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rims/transportbil/ford-transit-custom"])
      });
    }
  